module.exports = __webpack_public_path__ + "assets/img/error.823028f0.jpg";